import { render } from "./actions.vue?vue&type=template&id=3a3ce5f9&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"

import "./actions.vue?vue&type=style&index=0&id=3a3ce5f9&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3ce5f9"]])

export default __exports__